"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generator_createNewLevel = exports.go_dive_newLevel = exports.generator_newScenario = exports.reset = void 0;
var diveGeneratorManager_sidecar_1 = require("@dive/dive-generator/common/diveGeneratorManager-sidecar");
var diveTilemapGenerator_sidecar_1 = require("@dive/dive-generator/diveTilemapGenerator-sidecar");
var diveTileData_1 = require("@dive/tilemap/diveTileData");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageGameManager_sidecar_1 = require("@voyage/game-status/voyageGameManager-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var voyageFakeInfo_sidecar_1 = require("@voyage/text/voyageFakeInfo-sidecar");
var voyageMenuMain_sidecar_1 = require("@voyage/ui/voyageMenuMain-sidecar");
var diveBullets_sidecar_1 = require("@dive/entities/diveBullets-sidecar");
var diveSplatters_sidecar_1 = require("@dive/effects/diveSplatters-sidecar");
var diveSpells_sidecar_1 = require("@dive/spells/data/diveSpells-sidecar");
var diveSimulationDirector_sidecar_1 = require("@dive/simulation/diveSimulationDirector-sidecar");
var diveMultiUtilities_syncWorld_sidecar_1 = require("@dive/multi/diveMultiUtilities_syncWorld-sidecar");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var namespace = 'voyage-game-new-scenario';
function reset(keepHeroes) {
    console.log('!! GAME RESET', keepHeroes);
    voyageFakeInfo_sidecar_1.voyageFakeInfo.reset();
    if (keepHeroes) {
        diveCrew_sidecar_1.diveCrew.killAll_exceptHeroesAndPets();
    }
    else {
        diveCrew_sidecar_1.diveCrew.killAll('reset scenario, dont keep heroes');
    }
    // voyageBullets.killAll()
    // voyageParticles.killAll()
    // voyageSplatters.killAll()
    // voyageCarryable.killAll()
    // voyageUiMessage.setOpen(false)
    // voyageGameStatus.reset()
    // voyageStarmapGenerator.clear()
    diveBullets_sidecar_1.diveBullets.killAll();
    diveSplatters_sidecar_1.diveSplatters.killAll();
    diveSpells_sidecar_1.diveSpells.killAll();
    diveObjects_sidecar_1.diveObjects.killAll();
    // voyageTilemap.resetSystems()
}
exports.reset = reset;
function generator_newScenario(loadFromSave) {
    return __generator(this, function (_a) {
        console.log(namespace, 'start');
        voyageMenuMain_sidecar_1.voyageMenuMain.setOpen(false);
        // reset(true)
        go_dive_newLevel(true, loadFromSave);
        voyageGameManager_sidecar_1.voyageGameManager.goGame();
        console.log(namespace, 'end');
        return [2 /*return*/, 0];
    });
}
exports.generator_newScenario = generator_newScenario;
function go_dive_newLevel(isStartingLevel, loadFromSave) {
    if (isStartingLevel) {
        diveSimulationDirector_sidecar_1.diveSimulationDirector.get().levelNum = diveDebug_sidecar_1.diveDebug.debug_startLevelNum;
        diveSimulationDirector_sidecar_1.diveSimulationDirector.get().isSafeRoom = diveDebug_sidecar_1.diveDebug.debug_startInSafeRoom; // Start in safe room or no?
    }
    else {
        if (diveSimulationDirector_sidecar_1.diveSimulationDirector.get().isSafeRoom) {
            diveSimulationDirector_sidecar_1.diveSimulationDirector.get().levelNum++;
            diveSimulationDirector_sidecar_1.diveSimulationDirector.get().isSafeRoom = false;
        }
        else {
            diveSimulationDirector_sidecar_1.diveSimulationDirector.get().isSafeRoom = true;
        }
    }
    diveSimulationManager_sidecar_1.diveSimulationManager.addGenerator(generator_createNewLevel(isStartingLevel, loadFromSave, diveSimulationDirector_sidecar_1.diveSimulationDirector.get().levelNum, diveSimulationDirector_sidecar_1.diveSimulationDirector.get().isSafeRoom));
}
exports.go_dive_newLevel = go_dive_newLevel;
function generator_createNewLevel(isStartingLevel, loadFromSave, levelNum, isSafeRoom) {
    var tile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                reset(!isStartingLevel);
                diveSimulationManager_sidecar_1.diveSimulationManager.setMode('generating');
                console.log('resetting camera');
                voyageCamera_sidecar_1.voyageCamera.setCameraXY(0, 0);
                voyageCamera_sidecar_1.voyageCamera.setZoom(0.25);
                // Generate map
                diveTilemapGenerator_sidecar_1.diveTilemapGenerator.generate_initial_scenario_level(isStartingLevel, loadFromSave, levelNum, isSafeRoom);
                _a.label = 1;
            case 1:
                if (!diveGeneratorManager_sidecar_1.diveGeneratorManager.isRunning()) return [3 /*break*/, 3];
                return [4 /*yield*/, 0.1];
            case 2:
                _a.sent();
                return [3 /*break*/, 1];
            case 3:
                tile = diveTilemap_sidecar_1.diveTilemap.findFirstTile(function (t) { return t.tile1.type === diveTileData_1.EDiveTile.StairsUp; });
                if (tile) {
                    voyageCamera_sidecar_1.voyageCamera.centerOn(tile.x, tile.y);
                    voyageCamera_sidecar_1.voyageCamera.setZoom(0.5);
                }
                // Start simulation (TODO: another generator to startup?)
                // diveSimulationManager.setMode('game')
                // diveSimulationManager.setIsRunning(true)
                diveMultiUtilities_syncWorld_sidecar_1.diveMultiUtilities_syncWorld.diveMulti_syncWorld();
                return [2 /*return*/, 0];
        }
    });
}
exports.generator_createNewLevel = generator_createNewLevel;
